import { gsap } from 'gsap';

export function initPageTransition() {
  // 重複実行防止
  if (document.body.classList.contains('page-transition-init')) {
    return;
  }
  document.body.classList.add('page-transition-init');

  /* ====================================
  # ページ読み込み時のフェードイン
  ==================================== */

  // ページ読み込み完了時にフェードイン
  const fadeInPage = () => {
    // 初期状態で非表示に設定
    gsap.set('body', {
      opacity: 0
    });

    // ページ読み込み完了後にフェードイン
    window.addEventListener('load', () => {
      gsap.to('body', {
        opacity: 1,
        duration: 0.6,
        ease: 'power2.out'
      });
    });

    // 既に読み込み完了している場合（キャッシュされた場合など）
    if (document.readyState === 'complete') {
      gsap.to('body', {
        opacity: 1,
        duration: 0.6,
        ease: 'power2.out'
      });
    }
  };

  /* ====================================
  # ページ遷移時のフェードアウト
  ==================================== */

  const fadeOutPage = (callback) => {
    gsap.to('body', {
      opacity: 0,
      duration: 0.4,
      ease: 'power2.in',
      onComplete: callback
    });
  };

  /* ====================================
  # リンククリック時の処理
  ==================================== */

  const setupPageTransitions = () => {
    // 内部リンクを取得（外部リンクやハッシュリンクは除外）
    const internalLinks = document.querySelectorAll('a[href]');

    internalLinks.forEach(link => {
      const href = link.getAttribute('href');

      // 外部リンク、ハッシュリンク、mailto、tel、特殊属性のリンクは除外
      if (
        !href ||
        href.startsWith('#') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:') ||
        href.includes('://') ||
        link.hasAttribute('target') ||
        link.hasAttribute('download')
      ) {
        return;
      }

      link.addEventListener('click', (e) => {
        e.preventDefault();

        // フェードアウト後にページ遷移
        fadeOutPage(() => {
          window.location.href = href;
        });
      });
    });
  };

  /* ====================================
  # 初期化
  ==================================== */

  // ページフェードインを実行
  fadeInPage();

  // ページ遷移の設定
  setupPageTransitions();

  /* ====================================
  # ブラウザの戻る/進むボタン対応
  ==================================== */

  window.addEventListener('pageshow', (e) => {
    // ページがキャッシュから復元された場合
    if (e.persisted) {
      gsap.set('body', { opacity: 1 });
    }
  });

  // ページを離れる前の処理
  window.addEventListener('beforeunload', () => {
    gsap.set('body', { opacity: 0 });
  });
}